import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Results from './components/result/Results';
import SearchPage from './components/search/SearchPage';


function App() {
  return (
      <Routes>
        <Route path='/' element={<SearchPage />} />
        <Route path='response/:id' element={<Results />} />
        {/*<Route path='faq/:id/:text' element={<FaqTemplate />} />*/}
        {/*<Route path='faq/answer' element={<FaqTemplateAnswer />} />*/}
        {/* <Route path='*' element={<Notfound/>} /> */}
      </Routes>
  );
}

export default App;
